import React from 'react';

import Responsive from '@/components/Responsive';

import SortMenuDesktop from './index.desktop';
import SortMenuMobile from './index.mobile';
import { ListItemProps, SortMenuProps } from './types';

const SortMenu = <T extends ListItemProps>(props: SortMenuProps<T>) => {
  return (
    <Responsive>
      <Responsive.Default>
        <SortMenuDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <SortMenuMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default SortMenu;
